module.exports = __webpack_public_path__ + "img/teaching.87dbf5c4.png";